import { zodResolver } from "@hookform/resolvers/zod";
import {
    Box,
    CircularProgress,
    Grid,
    TextField,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { t } from "i18next";
import { useForm } from "react-hook-form";
import { z } from "zod";
import BasicDialog from "../../components/base/BasicDialog";
import { useToasts } from "../../hooks/useToasts";
import toast from "react-hot-toast"
import { SnackbarSuccess } from "../../components/base/SnackbarAlert/SnackbarSuccess";

import { useCreateClauseMutation } from "../../services/clausesService";
import { useCreateBankingMutation, useBankingFilteringData } from "../../services/bankingService";

import { ControlledSelect } from "../../components/form/ControlledSelect/ControlledSelect";
import MaskedTextFieldForm from "../../components/base/MaskedTextFieldForm/MaskedTextFieldForm";
import { CLAUSE_TAG } from "../../helpers/constants";

export const clauseFormSchema = z
    .object({
        clause_name: z.string(),
        clause_text: z.string(),
        clause_order: z.number(),
        clause_is_required: z.boolean(),
        clause_tag: z.string(),
    })


export function AddClauseDialog(props) {
    const { handleSubmit, control, formState, register, reset, setValue, watch } = useForm({
        resolver: zodResolver(clauseFormSchema),
        defaultValues: {clause_is_required: true},
    });

    const { onFormErrors, onServerError } = useToasts();

    const { mutate: addClause, isPending: isCreateClause } = useCreateClauseMutation({
        onSuccess: (data, variables, context) => {
            toast.custom(
                () => <SnackbarSuccess message={t("successfullyAdded")} />,
                {
                    position: "bottom-right",
                },
            );
            props.onClose()
        },
        onError: (error) => {
            onServerError(error);
        },
    });


    const onSubmit = (data) => {
        addClause({data:data})
    };
    
    const isFormValid =  watch('clause_name') && watch('clause_text') && watch('clause_order') && watch('clause_tag')

    if (isCreateClause) {
        return (
            <BasicDialog
                open={props.open}
                onClose={props.onClose}
                titleAlign={"center"}
                contentAlign={"center"}
                title="Loading..."
                maxWidth={"xs"}
                showDialogActions
                alwaysFullScreen={false}
            >
                <Box display="flex" justifyContent="center" p={4}>
                    <CircularProgress />
                </Box>
            </BasicDialog>
        );
    }

    return (
        <BasicDialog
            open={props.open}
            onClose={props.onClose}
            titleAlign={"center"}
            contentAlign={"center"}
            showTitle={true}
            title={t("page.clause_page.add_clause")}
            maxWidth={"sm"}
            
        >
            <Grid container rowSpacing={1}>
                <Grid item xs={12}>
                    <TextField
                        {...register("clause_name")}
                        fullWidth
                        disabled={false}
                        label={`${t("page.clause_page.clause_name")}*`}
                        size="small"
                        sx={{background: "white"}}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        {...register("clause_text")}
                        fullWidth
                        multiline
                        rows={6}
                        disabled={false}
                        label={`${t("page.clause_page.clause_text")}*`}
                        size="small"
                        sx={{background: "white"}}
                    />
                </Grid>
                <Grid item xs={12}>
                    <ControlledSelect
                        control={control}
                        sx={{background: "white"}}
                        name="clause_tag"
                        label={`${t("page.clause_page.clause_tag")}*`}
                        data={[{"value" : CLAUSE_TAG.RODO, "label": CLAUSE_TAG.RODO},{"value" : CLAUSE_TAG.MARKETING, "label": CLAUSE_TAG.MARKETING}]}
                    />
                </Grid>
                <Grid item xs={12}>
                    <ControlledSelect
                        control={control}
                        sx={{background: "white"}}
                        name="clause_order"
                        label={`${t("page.clause_page.clause_order")}*`}
                        data={ Array.from({length: 10}, (_, i) => i + 1).map(n=>({"value" : n, "label": `${n}`}))}
                    />
                </Grid>
                <Grid item xs={12}>
                    <ControlledSelect
                        control={control}
                        sx={{background: "white"}}
                        name="clause_is_required"
                        label={`${t("page.clause_page.clause_is_required")}*`}
                        data={[{"value" : true, "label": t('yes')},{"value" : false, "label": t('no')}]}
                    />
                    </Grid>
                <Grid item xs={12}>
                    <LoadingButton
                        loading={isCreateClause}
                        disabled={!isFormValid}
                        variant="contained"
                        color="primary"
                        sx={{ mt: 2 }}
                        onClick={handleSubmit(onSubmit, onFormErrors)}
                        fullWidth
                    >
                        {t("add")}
                    </LoadingButton>
                </Grid>
            </Grid>
        </BasicDialog>
    );
}
